import React, { useState, useEffect, useContext, useRef } from 'react';
import { Context } from '../../services/contexts/StateContext';
import * as S from './styles';
import imgFrente1 from "../../midia/vistoria/frente1.jpg";
import imgFrente2 from "../../midia/vistoria/frente2.JPG";
import imgFundo1 from "../../midia/vistoria/fundo1.jpg";
import imgFundo2 from "../../midia/vistoria/fundo2.JPG";
import imgchassi from "../../midia/vistoria/chassi.jpeg";
import imgvideo from "../../midia/vistoria/imgvideo.jpg";
import imgPainel from "../../midia/vistoria/painel.jpg";
import imgKM from "../../midia/vistoria/painel_KM.jpg";
import imgCapo from "../../midia/vistoria/capo.jpg";

// API
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';

//----------------------------------------------------
export function CameraSinistro({placa, ImgPosition, setarrayImgPosition, setabrirCamera, tipoVistoria}) {
    const { state, dispatch } = useContext(Context);
    const { parametroInit } = state.parametros;
    const { evento } = state.evento;
    
    // API Functions
    const { AtualizarIdEvento, PesqIdEvento } = ApiEvento();
    const { AtualizarArquivosVeiculo } = Api_Veiculos();

    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const mediaRecorderRef = useRef(null);
    const chunksRef = useRef([]); // Adicione esta linha para armazenar os chunks localmente

    const [stream, setStream] = useState(null);
    const [recording, setRecording] = useState(false);
    const [recordingTime, setRecordingTime] = useState(0); // contador de tempo
    const [videoURL, setVideoURL] = useState(null);

    const [chunks, setChunks] = useState([]);
    const [imagCaptured, setimagCaptured] = useState([]);
    const arrayPosicao = ["CHASSI", "FRENTE_DIR", "FRENTE_ESQ", "FUNDO_DIR", "FUNDO_ESQ", "MOTOR", "PAINEL", "KM PAINEL"];
    const [nomePosicao, setNomePosicao] = useState('');
    const [abrirMidia, setabrirMidia] = useState(false);

    //----------------------------------------------------

    // Atualiza o contador enquanto grava
    useEffect(() => {
        let interval = null;
        if (recording) {
            interval = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);
        } else {
            setRecordingTime(0);
            if (interval) clearInterval(interval);
        }
        return () => {
            if (interval) clearInterval(interval);
        };
    }, [recording]);

    // --------------------------------
    // iniciar a camera
    async function iniciarCamera() {
        setimagCaptured([]);
        setVideoURL(null);
        try {
            const constraints = {
                audio: false,
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    frameRate: { ideal: 10, max: 30 },
                    facingMode: "environment", //camera traseira
                },
            };
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            setStream(stream);
            if (videoRef.current) {
                videoRef.current.srcObject = stream;
            };
        } catch (error) {
            console.error("Erro ao acessar a camera", error);
        };
    };

    // Parar Camera
    async function PararCamera() {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
            setStream(null);

            setNomePosicao('');
            setRecording(false);
            setRecordingTime(0);
            setChunks([]); // limpa o estado
            setVideoURL(null); // limpa vídeo anterior
            chunksRef.current = []; // limpa os chunks locais

            if (mediaRecorderRef.current) {
                mediaRecorderRef.current.stop();
            }
        };
    };

    // Capturar foto
    async function CapturarFoto() {
        if (videoRef.current && canvasRef.current && stream) {
            const context = canvasRef.current.getContext('2d');

            // Ajustar Tamanho do canvas para resolução da camera
            const video = videoRef.current;
            canvasRef.current.width = video.videoWidth;
            canvasRef.current.height = video.videoHeight;

            //desenhando a imagen no canvas
            context.drawImage(video, 0, 0, canvasRef.current.width, canvasRef.current.height);

            // Adicionando data e hora na imagem
            const captureTime = new Date().toLocaleString();
            context.font = "30px Arial"; //"30px Arial"
            context.fillStyle = "white"; // Cor do texto
            context.strokeStyle = "black"; // Cor da borda
            context.lineWidth = 2; // Espessura da borda
            context.textAlign = "right"; // Alinha o texto à direita
            context.textBaseline = "bottom"; // Alinha o texto na parte inferior

            // Posicionando a data e hora na imagem
            context.strokeText(captureTime, canvasRef.current.width - 15, canvasRef.current.height - 15); // borda
            context.fillText(captureTime, canvasRef.current.width - 15, canvasRef.current.height - 15); // texto              

            // Converte o canvas para uma URL de imagem
            const imgURL = canvasRef.current.toDataURL('image/png', 1.0); // 1.0 é a qualidade da imagem 100% // 0.8 = 80%
    
            setimagCaptured((img) => [...img, imgURL]);
            // pode fazer o upload ou exibir a imagem
        };
    };

    // ----------------=========
    useEffect(() => {
        if (stream) {
        stream.getTracks().forEach(track => track.stop());
        setStream(null);
        }
    }, [imagCaptured])


    // nome imagens -----------
    const NomeImage = (imgUrl) => {
        removeImagCodigo();
        setNomePosicao('');
        
        const nome = { nome: `${nomePosicao}.png`, href: imgUrl };
        if (nome) {
            setarrayImgPosition((img) => [...img, nome]);
            setimagCaptured([]);
        }
    };

    // Iniciar Gravação video
    async function IniciarGravacao() {
        if (stream) {
            setRecordingTime(0); // zera o contador ao iniciar
            setChunks([]); // limpa o estado
            setVideoURL(null); // limpa vídeo anterior
            chunksRef.current = []; // limpa os chunks locais

            mediaRecorderRef.current = new MediaRecorder(stream, {
                mimeType: 'video/mp4',
            });
            mediaRecorderRef.current.ondataavailable = (event) => {
                if (event.data && event.data.size > 0) {
                    chunksRef.current.push(event.data); // armazena localmente
                }
            };
            mediaRecorderRef.current.start();
            setRecording(true);
        }
    };

    // Parar Gravação video
    async function PararGravacao() {
        if (stream){
            stream.getTracks().forEach(track => track.stop());
        }

        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
            setRecording(false);

            // Aguarda os dados serem Reproduzidos
            mediaRecorderRef.current.onstop = () => {
                if (chunksRef.current.length > 0) {
                    const blob = new Blob(chunksRef.current, { type: 'video/mp4' });
                    const url = URL.createObjectURL(blob);
                    setVideoURL(url);
                    setChunks([]); // limpa o estado para evitar problemas futuros
                } else {
                    setVideoURL(null);
                }
            };
        }
    };

    // Salvar video Gravado
    async function SalvarVideo() {
        removeImagCodigo();
        if (chunksRef.current.length > 0) {
            const blob = new Blob(chunksRef.current, { type: 'video/mp4' });
            const url = URL.createObjectURL(blob);
            const nome = { nome: `VIDEO.mp4`, href: url };
            if (nome) {
                setarrayImgPosition((img) => [...img, nome]);
                setVideoURL(null);
                setNomePosicao('');
                setChunks([]); // limpa o estado
                chunksRef.current = []; // limpa os chunks locais
                setRecordingTime(0);
                setRecording(false);
                setimagCaptured([]);
            }
        }
    };

    // ---------------
    const [apos2s, setapos2s] = useState(false);
    
    useEffect(() => {
      setTimeout(() => {
        setapos2s(true)
      },2000)
    }, [imagCaptured])

    // ----------------
    const [Codigo_href, setCodigo_href] = useState('');

    // Remover do ImgPosition a posição por Codigo_href
    function removeImagCodigo() {
        if (Codigo_href.length > 0) {
            Codigo_href.map(cod => {
                const updatedArray = ImgPosition.filter(t => t.href !== cod);
                setarrayImgPosition(updatedArray);
                setCodigo_href('');
                
            });
        };
    };
    
    // ----------------

    useEffect(() => {
        if (abrirMidia && nomePosicao === "VIDEO") {
            setVideoURL(Codigo_href[0])
        } else {
            setVideoURL(null);
        }
      
    }, [abrirMidia, Codigo_href])

    // ----------------

    // Função para converter base64 em File
    const converterBase64ParaFile = async (base64String, fileName) => {
        const response = await fetch(base64String);
        const blob = await response.blob();
        return new File([blob], fileName, { type: blob.type });
    };

    // Função para converter Blob URL em File
    const converterBlobParaFile = async (blobUrl, fileName) => {
        const response = await fetch(blobUrl);
        const blob = await response.blob();
        return new File([blob], fileName, { type: 'video/mp4' });
    };

    // ENVIAR ARQUIVOS----------------------
    const enviarArquivos = async () => {
        // if (ImgPosition?.length < 9) {
        //     alert('Erro: Deve ser capturado 8 imagens e 1 vídeo.');
        //     return;
        // };

        try {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: true }
            });

            // Converter todos os arquivos
            const arquivosConvertidos = [];
            
            for (const item of ImgPosition) {
                if (item.nome === 'VIDEO.mp4') {
                    // Converter vídeo
                    const videoFile = await converterBlobParaFile(item.href, item.nome);
                    arquivosConvertidos.push(videoFile);
                } else {
                    // Converter foto
                    const fotoFile = await converterBase64ParaFile(item.href, item.nome);
                    arquivosConvertidos.push(fotoFile);
                }
            };

            console.log('Arquivos convertidos prontos para envio:', arquivosConvertidos);

            // Aguardar um momento para garantir que o dispatch foi processado
            await new Promise(resolve => setTimeout(resolve, 100));

            // Chamar a função de envio
            if (tipoVistoria === 'vistoria_cadastro') {
                await AtualizarArquivosVeiculo({ tipoFile: "vistorias", arquivosConvertidos });
            } else {
                await AtualizarIdEvento({ tipoFile: "vistorias", arquivosConvertidos });
            }

            // Limpar arquivos capturados
            setarrayImgPosition([]);
            setNomePosicao('');
            
            // Recarregar evento para buscar arquivos do S3
            if (tipoVistoria !== 'vistoria_cadastro' && evento.id_Evento) {
                await PesqIdEvento(evento.id_Evento);
            } 

        } catch (error) {
            console.error('Erro ao enviar arquivos:', error);
            alert('Erro ao enviar arquivos. Por favor, tente novamente.');
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: false }
            });

        } finally {
            setabrirCamera(false);
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loadBola: false }
            });
        }
    };

    // Validação: verificar se todos os arquivos foram capturados
    const arquivosCompletos = ImgPosition?.length === 9 && 
        ImgPosition?.filter(img => img.nome === 'VIDEO.mp4').length === 1 &&
        ImgPosition?.filter(img => img.nome.endsWith('.png')).length === 8;

    // ###############################################################
    return (
        <S.bodyCamera 
        stream={stream || abrirMidia}
        fundoBloque={stream || nomePosicao}
        parar={recording}
        >
            <div className='fundoBloque' />
            
            {/*Mosaico de fotos */}
            {imagCaptured.length === 0 &&
            <S.Capturadas>
                <S.TituloHeader style={{width:"85%"}}>
                    <span> FOTOS VEICULO {placa} </span>
                </S.TituloHeader>

                {arrayPosicao.map((POSICAO, k) => (
                <div key={k} style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    {/* "CHASSI", "FRENTE_DIR", "FRENTE_ESQ", "FUNDO_DIR", "FUNDO_ESQ", "MOTOR", "PAINEL", "KM PAINEL" */}
                    <span>{POSICAO}</span>
                    
                    {ImgPosition?.filter(t => t.nome === `${POSICAO}.png`).map(i => i.href).length === 0 ?
                        <div style={{ display: "flex", width: "100px", height: "100px", backgroundColor: "white", alignItems: "center" }}>
                            <img
                            alt={`Capturada`}
                            style={{ display: "flex", backgroundColor: "white", width: "100px"}}
                            onClick={() => {iniciarCamera(); setNomePosicao(POSICAO)}}
                            src={
                                POSICAO === "FRENTE_DIR" ? imgFrente1 : POSICAO === "FRENTE_ESQ" ? imgFrente2 :
                                POSICAO === "FUNDO_DIR" ? imgFundo1 : POSICAO === "FUNDO_ESQ" ? imgFundo2 : 
                                POSICAO === "CHASSI" ? imgchassi : POSICAO === "MOTOR" ? imgCapo :
                                POSICAO === "PAINEL" ? imgPainel : POSICAO === "KM PAINEL" ? imgKM : null
                            }
                            />
                        </div>
                        :
                        <img
                        style={{ display: "flex", backgroundColor: "white", width: "100px", height: "100px" }}
                        src={ImgPosition?.filter(t => t.nome === `${POSICAO}.png`).map(i => i.href)}
                        alt={`Capturada`}
                        onClick={() => {setabrirMidia(true); setNomePosicao(POSICAO); setCodigo_href(ImgPosition?.filter(t => t.nome === `${POSICAO}.png`).map(i => i.href)) }}
                        />
                    }
                </div>
                ))}

                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <span>VIDEO 360°</span>

                    {ImgPosition?.filter(t => t.nome === `VIDEO.mp4`).map(i => i.href).length === 0 ?
                        <div style={{ display: "flex", width: "100px", height: "100px", backgroundColor: "white", alignItems: "center" }}>
                            <img
                            style={{ display: "flex", backgroundColor: "white", width: "100px" }}
                            src={imgvideo}
                            alt={`Capturada`}
                            onClick={() => {iniciarCamera(); setNomePosicao("VIDEO")}}
                            />
                        </div>
                        :
                        <video
                        style={{width: "100px", height: "100px", margin:"0", borderRadius:"0" }}
                        src={ImgPosition?.filter(t => t.nome === `VIDEO.mp4`).map(i => i.href)}
                        onClick={() => {setabrirMidia(true); setNomePosicao("VIDEO"); setCodigo_href(ImgPosition?.filter(t => t.nome === `VIDEO.mp4`).map(i => i.href))}}
                        />
                    }
                </div>

                {/* ------FINALIZAR----------------- */}

                <button
                onClick={enviarArquivos}
                style={{
                    backgroundColor: arquivosCompletos ? '#00ff21' : 'gray',
                    cursor: 'pointer',
                    padding: '12px 30px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    border: 'none',
                    borderRadius: '8px',
                    marginTop: '10px',
                    color: arquivosCompletos ? 'black' : 'white',
                    transition: 'all 0.3s ease',
                    boxShadow: arquivosCompletos ? '0 4px 6px rgba(0, 255, 33, 0.3)' : 'none'
                }}
                >
                    {arquivosCompletos ? '✓ ENVIAR VISTORIA' : `FALTA ${9 - ImgPosition?.length} IMAGENS`}
                </button>
            </S.Capturadas>
            }

            {/* ---------CAMERA ATIVA--------- */}
            <div style={{ display: "flex", zIndex:"2", flexDirection: "column", alignItems: "center", }}>                
                {(nomePosicao === "VIDEO" && !abrirMidia) ?
                <div className='div01video' style={{flexDirection:"column", maxWidth: "500px"}}>
                    {!videoURL ?
                    <>
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "90%"}}>
                        <S.fechar onClick={()=>PararCamera()}>
                            <span style={{ fontSize: "15px", padding: "2px 6px" }}>X</span>
                        </S.fechar >
                    </div>
                    <div className='div02'>
                        <div className='contador'>
                            <span>●</span> 
                            {String(Math.floor(recordingTime / 60)).padStart(2, '0')}:{String(recordingTime % 60).padStart(2, '0')}
                        </div>

                        <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            muted
                        />
                        <canvas ref={canvasRef} style={{ display: "none" }} />
                    </div>
                    </>
                    :

                    // Exibir o vídeo após a gravação */}
                    <div style={{ display:"flex", zIndex:"2", maxWidth: "500px", borderRadius: "10px", position:"fixed", top:"0", bottom:"0", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
                        <video
                            src={videoURL}
                            controls
                            autoPlay
                        />
                        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                            {/* <button onClick={baixarVideo}> Baixar </button> */}
                            <button onClick={()=>{SalvarVideo()}}> Salvar </button>
                            <button onClick={()=>{iniciarCamera()}}> Repetir </button>
                        </div>
                    </div>
                    }
                </div>

                :

                // aberta camera para FOTOS
                imagCaptured.length === 0 ?
                <div className='div01' style={{flexDirection:"column", maxWidth: "500px"}}>
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "90%"}}>
                        <S.fechar onClick={()=>PararCamera()}>
                            <span style={{ fontSize: "15px", padding: "2px 6px" }}>X</span>
                        </S.fechar >
                    </div>

                    <video
                        ref={videoRef}
                        autoPlay
                        playsInline
                        muted
                    />
                    <canvas ref={canvasRef} style={{ display: "none" }} />
                </div> 

                :

                // mostrar fotos capturadas
                imagCaptured.map((img, index) => (
                <div key={index} style={{ display: "flex", zIndex:"2", position: "fixed", top: "25px", width: "90vw", alignItems: "center", flexDirection: "column"}}>
                    <h2 style={{color:"white"}}>{nomePosicao}</h2>
                    <img
                        src={img}
                        alt={`Capturada ${index + 1}`}
                        style={{ width: "95%", maxWidth: "500px", borderRadius: "10px", border: "2px solid blue" }}
                    />
                    <div style={{ display: "flex", gap: "10px" }}>
                        <button
                            onClick={() => NomeImage(img)}
                            style={{ display: "flex", marginTop: "10px", backgroundColor: "#008cff", color: "white" }}>
                            Ficou Otima
                        </button>

                        <button
                            onClick={() => iniciarCamera()}
                            style={{ display: "flex", marginTop: "10px", backgroundColor: "red" }}>
                            Não Gostei
                        </button>
                    </div>
                </div>
                ))
                }

                {/* Botoes Camera */}
                <div style={{ display: stream?.active ? "flex" : "none" , zIndex:"3", alignItems:"center", justifyContent:'center', maxWidth: "500px" }}>
                    {nomePosicao === "VIDEO"?
                    <>
                    {recording  ?
                    <button onClick={PararGravacao} className='capturar'/>
                    :
                    <button onClick={IniciarGravacao} className='capturar'/>
                    }
                    </>
                    :
                    <button onClick={CapturarFoto} className='capturar' />
                    }
                </div>
            </div>

            {/* Abrir VIDEO */}
            {(abrirMidia && videoURL) &&
            <S.Play>
                <video
                src={videoURL}
                controls
                autoPlay
                />
                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                    <button onClick={()=>{iniciarCamera(); setabrirMidia(false); setNomePosicao("VIDEO"); setCodigo_href(ImgPosition?.filter(t => t.nome === `VIDEO.mp4`).map(i => i.href))}}> 
                        NOVO VIDEO 
                    </button>
                    <button onClick={()=>{setabrirMidia(false); setNomePosicao('')}}> X FECHAR </button>
                </div>
            </S.Play>
            }

            {/* Abrir FOTO */}
            {(abrirMidia && ImgPosition?.filter(t => t.nome === `${nomePosicao}.png`).length > 0) && 
            <S.Play>
                <img
                src={ImgPosition?.filter(t => t.nome === `${nomePosicao}.png`).map(i => i.href)}
                alt={`Capturada`}
                style={{ width: "95%", maxWidth: "500px", borderRadius: "10px", border: "2px solid blue" }}
                />
                <div style={{ display: "flex", gap: "10px" }}>
                    <button
                    onClick={() => {iniciarCamera(); setabrirMidia(false); setCodigo_href(ImgPosition?.filter(t => t.nome === `${nomePosicao}.png`).map(i => i.href))}}
                    style={{ display: "flex", marginTop: "10px", backgroundColor: "#008cff", color: "white" }}>
                    Repetir
                    </button>

                    <button
                    onClick={() => {setabrirMidia(false); setNomePosicao('')}}
                    style={{ display: "flex", marginTop: "10px", backgroundColor: "red" }}>
                    X Fechar 
                    </button>
                </div>
            </S.Play>
            }           

        </S.bodyCamera>
    );
};

